import React from 'react';
import _get from 'lodash/get';

import Tags from '../../containers/Tags';
import MessageBody from 'bdvp-common/src/components/MessageBody';
import SectionTemplate from '../SectionTemplate';
import Heading from '../Heading';

const Message = ({
    message,
}) => {

    const noMesssage = typeof message === 'undefined';

    if (noMesssage || (!noMesssage && typeof message.title === 'undefined' && typeof message.body === 'undefined')) {

        return null;

    }

    const { title = '', body ='' } = message;

    return (
        <SectionTemplate
            heading={<Heading>{title}</Heading>}
            tags={<Tags />}
            body={<MessageBody content={body} />}
        />
    );

};

export default Message;
